import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { ToastrService } from 'ngx-toastr';
import { UserDealersModel } from '../../../business-entities/dealer-details.model';
import { DealerViewModel } from '../../../business-entities/dealer-view-model';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { MechanicService } from '../../../business-services/mechanic.service';
import { CookieService } from 'ngx-cookie-service';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { UserDataService } from 'src/app/DataServices/user-data.service';
@Component({
  selector: 'app-service-mechanic-wise-report',
  templateUrl: './service-mechanic-wise-report.component.html',
  styleUrls: ['./service-mechanic-wise-report.component.css'],
})
export class ServiceMechanicWiseReportComponent implements OnInit {
  dealerId: string = '';
  isDealerRequired: boolean;
  dealerList: DealerViewModel[] = [];
  showData: boolean = false;
  ServiceMechanicWisedata: any;
  tblColumns: Array<string> = [];
  constructor(
    private dealerBusinessService: DealerBusinessService,
    private mechanicService: MechanicService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private cookieservice: CookieService,
    private excelService: ExcelService,
    private userService: UserDataService
  ) {}

  ngOnInit(): void {
    this.dealerId = this.userService.currentUserValue.defaultDealerId;
    this.getUserDealers();
    if(this.dealerId != ''){
      this.onSearchReport();
    }
  }
  async getUserDealers() {
    this.spinner.show();
    await this.dealerBusinessService
      .getUserDealersDropdown()
      .then((response) => {
        this.dealerList = this.mapDealer(response.userDealersModel);
        this.spinner.hide();
      });
  }
  onDealerSelected(dealerId: string) {
    this.resetData();
    if (dealerId) {
      this.isDealerRequired = false;
      this.dealerId = dealerId;
    } else {
      this.isDealerRequired = true;
      this.dealerId = null;
    }
  }

  resetData() {
    this.showData = false;
    this.ServiceMechanicWisedata = [];
  }

  mapDealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach((element)=>{
        let single = Object();
        single.value = element.dealerId;
        single.text = element.dealerName;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  onSearchReport() {
    if (!isNullOrUndefined(this.dealerId)) {
      this.loadReport();
    } else {
      this.isDealerRequired = true;
    }
  }

  async loadReport() {
    this.spinner.show();
    let Language = this.cookieservice.get('userSelectedLanguage')
    this.mechanicService
      .GetServiceMechanicWiseByDealer(this.dealerId,Language)
      .then((response) => {
        if (response && response.responseCode == Constant.SuccessResponseCode)
        {
          this.tblColumns = response.responseObject.headers;
          this.ServiceMechanicWisedata = response.responseObject.values;
          if (!isNullOrUndefined(this.ServiceMechanicWisedata)) {
            this.showData = true;
          }
        } else this.toastr.error(this.translate.instant('lblDataNotAvailable'));
        this.spinner.hide();
      });

    this.spinner.hide();
  }
  // Export functionality
  public async  exportAsXLSX() {
    if (!isNullOrUndefined(this.dealerId)) {
      this.loadReport();
    } else {
      this.isDealerRequired = true;
      return;
    }
    const excelData = this.ExcelDataMapping(this.ServiceMechanicWisedata);
    this.excelService.exportAsExcelFile(excelData, 'Service_Mechanic_Wise_Report');
  }

  public async onDownloadPDF() {
    if (!isNullOrUndefined(this.dealerId)) {
      this.loadReport();
    } 
    else {
      this.isDealerRequired = true;
      return;
    }
    this.generatePDF();
  }

  ExcelDataMapping(data: any[]): any[] {
    return data.map(row => {
      const rowData = {};
      this.tblColumns.forEach((column, index) => {
        rowData[column] = row[index];
      });
      return rowData;
    });
  }
  generatePDF() {
    const doc = new jsPDF('landscape');

    autoTable(doc, {
      head: [this.tblColumns],
      body: this.ServiceMechanicWisedata,
      margin: { top: 3, left: 3, right: 3, bottom: 3 },
      styles: { fontSize: 8 },
      columnStyles: this.tblColumns.reduce((acc, _, index) => {
        acc[index] = { cellWidth: 'auto' };
        return acc;
      }, {}),
    });
    doc.save('Service_Mechanic_Wise_Report.pdf');
  }
}
